import axiosClient from "../../api/axiosClient";
import customNotification from "../../components/notification";
import moment from "moment";

const playResponsibilityModel = {
    state: [],
    reducers: {
        setData(state, payload) {
            return { ...state, [payload.name]: payload.data,...payload };
        },
    },
    effects: (dispatch) => ({
        async addplayResponsibilityData(payload) {
            await axiosClient.post('/content/up_play_responsibility', payload).then(res => {
                if (res.data.status === 200) {
                    // getBalanceData(payload)
                    this.getplayResponsibilityShow(payload)
                    customNotification(res.data.message, "success")
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        },
        async getplayResponsibilityShow(payload) {
            await axiosClient.post('/content/play_responsibility', payload).then(res => {
                if (res.data.status === 200) {
                   this.setData({ name: "responsibility", data: res.data });
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        }
    }),
};

export default playResponsibilityModel;